import axios from '../../axios';

export default {
  namespaced: true,
  state: {},
  getters: {
    currentContactId: (state, getters) => {
      if ($cookies.get('currentContactId')) return parseInt($cookies.get('currentContactId'));
    },
  },
  mutations: {
    setCurrenctContactId(state, contactId) {
      if (contactId) $cookies.set('currentContactId', contactId, '3m', null, null, false);
      else $cookies.remove('currentContactId');
    },
  },
  actions: {

    // input = { email* : string, title: string, firstName*: string, lastName*: string, countryId : int, ga_ClientId : string  }   (* mandatory fields, if not set BadRequest will be returned)
    // response = { contactId: int, success: boolean }
    emailSubfooter({ commit, dispatch, getters }, emailSub) {
      emailSub.newsletter = true;
      emailSub.pdfRequestVillaId = 0;

      return new Promise((resolve, reject) => {
        axios.post('/core/contacts/emailsub/footer', emailSub).then((res) => {
          // set currentContactId
          commit('contacts/setCurrenctContactId', res.data.contactId, { root: true });
          resolve(res.data);
        }).catch((err) => { reject(err); });
      });
    },

    // input = { email* : string }   (* mandatory fields, if not set BadRequest will be returned)
    // response = { contactId: int, success: boolean }
    emailSubYieldify({ commit, dispatch, getters }, emailSub) {
      // for yieldify we only give email
      emailSub.title = '';
      emailSub.firstName = '';
      emailSub.lastName = '';
      emailSub.countryId = 0;
      emailSub.newsletter = true;
      emailSub.pdfRequestVillaId = 0;

      return new Promise((resolve, reject) => {
        axios.post('/core/contacts/emailsub/yieldify', emailSub).then((res) => {
          // console.log(emailSub);
          resolve(res.data);
        }).catch((err) => { reject(err); });
      });
    },

    // input = { email* : string }   (* mandatory fields, if not set BadRequest will be returned)
    // response = { contactId: int, success: boolean }
    emailSubNewDestination({ commit, dispatch, getters }, emailSub) {
      // for yieldify we only give email
      emailSub.title = '';
      emailSub.firstName = '';
      emailSub.lastName = '';
      emailSub.countryId = 0;
      emailSub.newsletter = true;
      emailSub.pdfRequestVillaId = 0;

      return new Promise((resolve, reject) => {
        axios.post('/core/contacts/emailsub/newdestination', emailSub).then((res) => {
          // console.log(emailSub);
          resolve(res.data);
        }).catch((err) => { reject(err); });
      });
    },

    // input = { email* : string, title: string, firstName*: string, lastName*: string, countryId : int, ga_ClientId : string, pdfRequestVillaId : int, newsletter : bool  }   (* mandatory fields, if not set BadRequest will be returned)
    // response = { contactId: int, success: boolean }
    emailSubPdfRequest({ commit }, emailSub) {
      return new Promise((resolve, reject) => {
        axios.post('/core/contacts/emailsub/pdfrequest', emailSub).then((res) => {
          // set currentContactId
          // console.log(res.data);
          commit('contacts/setCurrenctContactId', res.data.contactId, { root: true });
          resolve(res.data);
        }).catch((err) => { reject(err); });
      });
    },

    setMallorcaInterest({ }, token) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'POST',
          url: '/core/contacts/mallorcainterest/bytoken',
          headers: {
            token,
          },
        }).then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
      });
    },

    setFlagByToken({ }, payload) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'POST',
          url: `/core/contacts/setflag/${payload.flagname}/bytoken`,
          headers: {
            token: payload.token,
          },
        }).then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
      });
    },

  },

};
